jQuery(function($) {
    // Vars //
    var $body = $('body');
    var $window = $(window);
    var $header = $('header');

    // Functions
    navOnScroll();
    backToTop();
    sliderSetup();
    featureProductSliderSetup();
    contentBlockSliderSetup();
    logoSliderBlockSetup();
    didYouKnowSlider();

    // Onclick Events
    $body
        .on('click', 'a.scroll-to-top', function (e) {
            e.preventDefault();
            var $trigger = $(this);

            $("html, body").animate({ scrollTop: 0 }, 1500);
            return false;
        })
        .on('click', '.js-mobile-trigger', function (e) {
            e.preventDefault();
            var $trigger = $(this);
            // changed to apply class to all mobile triggers so I can have multiple on page
            var $mobileTriggers = $('.js-mobile-trigger');
            if ($mobileTriggers.hasClass('active')) {
                $mobileTriggers.removeClass('active');
                $body.removeClass('hamburger-menu-active');
                $body.removeClass('no-scroll');
            }
            else {
                $mobileTriggers.addClass('active');
                $body.addClass('hamburger-menu-active');
                $body.addClass('no-scroll');
            }
        })
        .on('click', '.js-footer-accordion-trigger', function (e) {
            e.preventDefault();
            var $accordion = $(this).closest('.footer-accordion');
            var $accordionContent = $accordion.find('.footer-accordion__content');
            if ($accordion.hasClass('active')) {
                $accordion.removeClass('active');
                $accordionContent.slideUp(350);
            } else {
                $accordion.addClass('active');
                $accordionContent.slideDown(350);
            }
        })
        .on('click', '.js-accordion-trigger', function (e) {
            e.preventDefault();
            var $accordion = $(this).closest('.accordion');
            var $accordionContent = jQuery($accordion).find('.accordion__content');
            if ($accordion.hasClass('open')) {
                $accordion.removeClass('open');
                $accordionContent.slideUp();
            } else {
                $accordion.addClass('open');
                $accordionContent.slideDown();
            }
        })
        // mobile menu dropdown handling
        .on('click', '.menu-item-dropdown-toggle', function(e) {
            e.preventDefault();
            var $this = $(this);
            $navItem = $this.closest('.nav-list__item');
            $dropdownMenu = $navItem.children('.nav-list__dropdown');
            $navItem.toggleClass('submenu-active');

            $dropdownMenu.toggleClass('active');
            $dropdownMenu.slideToggle();

        })
        // when dropdown menus have headers on mobile (see explorate, veto for examples)
        .on('click', '.dropdown-header-back', function(e) {
            e.preventDefault();
            var $this = $(this);
            $this.closest('.nav-list__item').removeClass('submenu-active');
            $this.closest('.nav-list__dropdown').removeClass('active').slideToggle();

        });
    ;

    // Select2 init
    //ginput_container_select
    $('select.gfield_select').select2({
        closeOnSelect: false,
        dropdownParent: $('.ginput_container_select')
    });

    // Resize Functions //
    var resizeThreshold;
    $(window).on('resize', function () {
        if (resizeThreshold) {
            clearTimeout(resizeThreshold);
        }

        resizeThreshold = setTimeout(function () {
            setTimeout(function () {
                backToTop();
                sliderSetup();
                featureProductSliderSetup();
                contentBlockSliderSetup();
                logoSliderBlockSetup();
                didYouKnowSlider();
            }, 100);
        }, 200);
    });
});

